// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8d406b44","220":"fd33c405","703":"6fc2cd6c","799":"41cd328b"}[chunkId] + ".chunk.js";
};